"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SecretType;
(function (SecretType) {
    SecretType["AETERNITY"] = "AETERNITY";
    SecretType["AVAC"] = "AVAC";
    SecretType["BSC"] = "BSC";
    SecretType["BITCOIN"] = "BITCOIN";
    SecretType["ETHEREUM"] = "ETHEREUM";
    SecretType["GOCHAIN"] = "GOCHAIN";
    SecretType["LITECOIN"] = "LITECOIN";
    SecretType["TRON"] = "TRON";
    SecretType["VECHAIN"] = "VECHAIN";
    SecretType["NEO"] = "NEO";
    SecretType["MATIC"] = "MATIC";
})(SecretType = exports.SecretType || (exports.SecretType = {}));
//# sourceMappingURL=SecretType.js.map